import type { Status } from "src/types/audits";

export const getColorByAuditStatus = (status?: Status): string => {
  const colorMap = {
    queued: "#FFD700",
    success: "#39D4A5",
    fail: "#FF0000",
    "in progress": "#FFA500",
    "waiting for invite acceptance": "#ccb0d9",
  };

  return status ? colorMap[status] : "transparent";
};
